<template>
  <!-- begin:: Header -->
  <header id="kt_header" class="nv-header">
    <div class="nv-container nv-header__inner">
      <router-link to="/" class="nv-header__brand" aria-label="Nilvera">
        <img
            alt="Nilvera"
            :src="layoutConfig('self.logo.default')"
            class="nv-header__logo"
        />
        <span class="nv-header__divider"></span>
        <span class="nv-header__product">Aktivasyon Portalı</span>
      </router-link>

      <div class="nv-header__actions">
        <a href="tel:08502514010" class="nv-header__link d-none d-md-inline-flex">
          <v-icon small>mdi-phone-outline</v-icon>
          <span>0850 251 40 10</span>
        </a>
        <a href="mailto:destek@nilvera.com" class="nv-header__link d-none d-lg-inline-flex">
          <v-icon small>mdi-email-outline</v-icon>
          <span>destek@nilvera.com</span>
        </a>

        <div v-if="certificateName" class="nv-header__user">
          <span class="nv-header__avatar">{{ certificateInitials }}</span>
          <span class="nv-header__user-text d-none d-sm-flex">
            <small>Giriş Yapılan Sertifika</small>
            <strong :title="certificateName">{{ certificateName }}</strong>
          </span>
        </div>
      </div>
    </div>
  </header>
  <!-- end:: Header -->
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "KTHeader",
  computed: {
    ...mapGetters(["layoutConfig", "getCertificate"]),

    /**
     * Sertifika ile giriş yapılmışsa (firma / başvuru ekranları) sertifika sahibinin adı
     */
    certificateName() {
      if (!["dashboard", "create"].includes(this.$route.name)) return null;
      return this.getCertificate && this.getCertificate.CommonName ? this.getCertificate.CommonName : null;
    },

    certificateInitials() {
      if (!this.certificateName) return "";
      return this.certificateName
          .trim()
          .split(/\s+/)
          .slice(0, 2)
          .map(x => x.charAt(0))
          .join("")
          .toLocaleUpperCase("tr");
    }
  }
};
</script>
